import { useState } from 'react'
import { useNavigate } from 'react-router'
import { Label } from '@/design-system/atoms/Label'
import { Input } from '@/design-system/atoms/Input'
import { Button } from '@/design-system/atoms/Button'
import { Alert } from '@/design-system/molecules/Alert'
import { authService } from '../../services/authService'

export default function ResetPasswordForm() {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setMessage('')

    if (!email) {
      setError('Por favor, digite seu email')
      return
    }

    setIsLoading(true)

    try {
      await authService.resetPassword(email)
      setMessage(
        'Se esse email estiver cadastrado, voc� receber� instru��es para redefinir sua senha.'
      )
    } catch {
      setError('Erro ao solicitar redefini��o de senha. Tente novamente.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="flex flex-col flex-1">
      <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
        <div>
          <div className="mb-5 sm:mb-8">
            <h1 className="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
              Recuperar Senha
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Digite seu email para receber instru��es de recupera��o
            </p>
          </div>

          <div>
            <form onSubmit={handleSubmit}>
              {error && (
                <Alert variant="error" className="mb-4">
                  {error}
                </Alert>
              )}

              {message && (
                <Alert variant="success" className="mb-4">
                  {message}
                </Alert>
              )}

              <div className="space-y-6">
                <div>
                  <Label>
                    E-mail <span className="text-error-500">*</span>
                  </Label>
                  <Input
                    type="email"
                    placeholder="seu@email.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    disabled={isLoading}
                    required
                  />
                </div>

                <div className="space-y-4">
                  <Button
                    type="submit"
                    className="w-full"
                    size="sm"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Enviando...' : 'Enviar'}
                  </Button>

                  <button
                    type="button"
                    onClick={() => navigate('/signin')}
                    className="w-full text-sm text-brand-500 hover:text-brand-600 dark:text-brand-400"
                  >
                    Voltar para o login
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
